<template>
  <div>
    <v-card outlined flat tile>
      <v-card-title>
        <v-row class="pa-0 ma-0">
          <v-col class="py-1" cols="12" sm="6">
            <v-text-field
              dense
              v-model="search"
              append-icon="fa-brands fa-searchengin"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
          </v-col>
          <v-col class="py-1" cols="12" sm="6">
            <div class="d-flex flex-row justify-end">
              <v-btn class="mx-1" @click="add()" color="primary"> add </v-btn>
              <v-btn class="mx-1" color="trinary"> extract </v-btn>
            </div>
            <div class="d-flex flex-row justify-end">
              <v-checkbox
                v-if="slots.find((slot) => slot.type === 'image') != undefined"
                v-model="showImages"
                :ripple="false"
                hide-details=""
                color="primary"
                label="show images"
                dense
              >
              </v-checkbox>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :loading="tableLoading"
        item-key="id"
        :server-items-length="rows"
        :options.sync="options"
        loading-text="Data currently loading..."
        dense
        :headers="headers"
        :items="fetchedData"
      >
        <template v-for="(slot, i) in slots" v-slot:[slot.title]="{ item }">
          <v-switch
            v-if="slot.type == 'switch'"
            :key="i"
            :true-value="1"
            :false-value="0"
            @change="save(item.id, slot.header, item[slot.header])"
            v-model="item[slot.header]"
            hide-details=""
            class="ma-0"
            dense
          ></v-switch>
          <v-edit-dialog  
            :large="
              slot.type == 'slideshow' || slot.type == 'table' ? false : true
            "
            @close="(image = null), (image_base64 = ''), (image_url = '')"
            class="pa-0 lg"
            v-else
            :key="i"
            @save="
              slot.type == 'image'
                ? saveImg(item.id)
                : save(
                    item.id,
                    slot.col,
                    slot.type == 'select'
                      ? item[slot.header].id
                      : item[slot.header]
                  )
            "
            :return-value.sync="item[slot.header]"
            >
            
            <span v-if="slot.type == 'textarea'" class="text-trunc-2">
              {{ item[slot.header] }}
            </span>
            <span v-if="slot.type == 'text'"> {{ item[slot.header] }} </span>
            <span v-if="slot.type == 'date'"> {{ item[slot.header] }} </span>
            <span v-if="slot.type == 'table'">
              {{ item[slot.header].length }}
            </span>
            <span v-if="slot.type == 'select'">
              {{ item[slot.header] == null ? "N/a" : item[slot.header].title }}
            </span>
            <span v-if="slot.type == 'slideshow'">
              {{ item[slot.header].length }}
            </span>
            <span v-if="slot.type == 'image'">
              <div v-if="showImages">
                <v-row class="ma-0 pa-0" align="center" justify="center">
                  <v-img
                    v-if="item[slot.header] != null"
                    class="mx-auto"
                    height="50"
                    width="50"
                    contain
                    :src="
                      $store.state.imagePath + slot.link + item[slot.header]
                    "
                  >
                  </v-img>
                </v-row>
              </div>
              <span v-else class="text-trunc">
                {{
                  item[slot.header] == null ? "N/a" : item[slot.header]
                }}</span
              >
            </span>
            <template v-slot:input>
              <v-container class="pa-1">
                <v-carousel
                  v-if="slot.type == 'slideshow'"
                  height="30vh"
                  hide-delimiter-background
                  hide-delimiters
                  v-model="carousel"
                  cycle
                  show-arrows-on-hover
                  reverse
                  continuous
                >
                  <v-carousel-item
                    v-for="(img, i) in item[slot.header]"
                    :key="i"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  >
                    <v-img
                      class="mx-auto"
                      contain
                      height="30vh"
                      width="30vh"
                      :src="img.img"
                    >
                    </v-img
                  ></v-carousel-item>
                </v-carousel>

                <v-textarea style="width:80vh" full-width
                  v-else-if="slot.type == 'textarea'"
                  dense
                  v-model="item[slot.header]"
                ></v-textarea>
                <v-text-field
                  hide-details=""
                  v-else-if="slot.type == 'text'"
                  dense
                  v-model="item[slot.header]"
                  single-line
                  counter
                ></v-text-field>
                <v-menu
                  v-else-if="slot.type == 'date'"
                  close-on-click
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="item[slot.header]"
                      prepend-icon="fa-solid fa-calendar-days"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item[slot.header]"></v-date-picker>
                </v-menu>
                <v-data-table
                  v-else-if="slot.type == 'table'"
                  height="200"
                  hide-default-footer
                  dense
                  :headers="[
                    { text: 'Id', value: 'id' },
                    { text: 'Title', value: 'title' },
                  ]"
                  :items="item[slot.header]"
                ></v-data-table>

                <v-container v-else-if="slot.type == 'image'">
                  <div>
                    <div v-if="image != null">
                      <v-img
                        class="mx-auto"
                        :src="image_url"
                        :aspect-ratio="4 / 3"
                        contain
                        min-width="150"
                        v-if="image_url != ''"
                      >
                      </v-img>
                    </div>
                    <div v-else>
                      <v-img
                        class="mx-auto"
                        min-width="150"
                        v-if="item[slot.header] != null"
                        :src="
                          $store.state.imagePath + slot.link + item[slot.header]
                        "
                        :aspect-ratio="4 / 3"
                        contain
                      >
                      </v-img>
                    </div>
                  </div>
                  <div>
                    <v-row class="ma-0">
                      <v-btn
                        small
                        class="ma-1"
                        depressed
                        tile
                        color="primary trinary--text"
                        @click="document.getElementById('uploader').click()"
                        >Upload
                        <v-file-input
                          id="uploader"
                          color="trinary"
                          prepend-icon=""
                          class="ma-0"
                          hide-details=""
                          hide-input
                          hide-spin-buttons
                          @change="Preview_image()"
                          v-model="image"
                          dense
                          accept="image/*"
                          show-size
                          label="Select image"
                        ></v-file-input>
                      </v-btn>

                      <v-btn
                        small
                        v-if="item[slot.header] != null"
                        class="ma-1"
                        depressed
                        tile
                        color="green trinary--text"
                      >
                        Download
                        <v-icon small color="trinary">fa-solid fa-download</v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </v-container>
                <v-select
                  v-else-if="slot.type == 'select'"
                  return-object
                  single-line
                  cache-items
                  dense
                  v-model="item[slot.header]"
                  item-text="title"
                  item-value="id"
                  :items="slot.data"
                ></v-select>
              </v-container>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon x-small @click="confirmDelete(item)">
          fa-solid fa-trash </v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <ConfirmDialog
      @confirm="deleteItem()"
      title="Confirmation required"
      text="Are you sure you want to submit this action?."
      confirmText="Delete"
      cancelText="Cancel"
    />
  </div>
</template>
<script >
import ConfirmDialog from "./ConfirmDialog.vue";
import axios from "@/plugins/http.service.js";
export default {
  components: {
    ConfirmDialog,
  },
  props: {
    headers: { type: Array, required: true },
    slots: { type: Array, required: true },
    apiLink: { type: String, required: true },
    apiDeleteLink: { type: String, required: true },
    apiSaveLink: { type: String, required: true },
    apiSaveImgLink: { type: String, required: false },
  },

  data: () => ({
    document,
    carousel: 0,
    showImages: false,
    status: false,
    selectedItem: null,
    loaded: false,
    valid: true,
    tableLoading: false,
    addDialog: false,
    chartData: {},
    rows: 0,
    search: "",
    initialLoad: true,
    options: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 10,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: [],
    },
    offset: 0,
    fetchedData: [],
    image_url: "",
    image_base64: "",
    image: null,
    image_title: "",
  }),
  mounted() {},
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true,
    },
    search() {
      this.fetchEntriesDebounced();
    },
  },
  methods: {
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });
    },
    Preview_image() {
      if (this.image == null) {
        this.image_url = "";
        this.image_base64 = "";
      } else {
        this.getBase64(this.image).then((res) => {
          this.image_base64 = res;
        });
        this.image_url = URL.createObjectURL(this.image);
        this.image_title = this.image.name;
      }
    },
    save(item_id, col, val) {
      this.$store.state.loading = true;
      axios
        .post(this.apiSaveLink, {
          item_id: item_id,
          col: col,
          val: val,
        })
        .then((res) => {
          if (res.data.responseCode === 1) {
            this.$store.state.loading = false;
          } else this.$store.state.loading = false;
        });
    },
    saveImg(item_id) {
      this.$store.state.loading = true;
      axios
        .post(this.apiSaveImgLink, {
          item_id: item_id,
          image_base64: this.image_base64,
          image_title: this.image_title,
        })
        .then((res) => {
          if (res.data.responseCode === 1) {
            this.$store.state.loading = false;
          } else this.$store.state.loading = false;
        });
    },
    fetch(disableLoading) {
      if (!disableLoading) this.$store.state.loading = true;
      else {
        this.tableLoading = true;
      }
      const sortBy =
        this.options.sortBy.length > 0
          ? this.options.sortBy[0] +
            (this.options.sortDesc[0] ? " ASC" : " DESC")
          : "";

      axios
        .post(this.apiLink, {
          val: this.search,
          sortBy: sortBy,
          limit: this.options.itemsPerPage,
          offset:
            this.options.itemsPerPage * this.options.page -
            this.options.itemsPerPage,
        })
        .then((res) => {
          this.$store.state.loading = false;
          this.tableLoading = false;
          if (res.data.responseCode === 1) {
            this.fetchedData = res.data.data;
            this.rows = res.data.rows;
          }
        });
    },

    add() {
      this.$emit("add");
    },

    fetchEntriesDebounced() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.fetch(true);
      }, 500);
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.$store.commit("openConfirmDialog");
    },
    deleteItem() {
      this.tableLoading = true;
      axios
        .post(this.apiDeleteLink, {
          id: this.selectedItem.id,
        })
        .then(() => {
          const index = this.fetchedData.indexOf(this.selectedItem);
          this.fetchedData.splice(index, 1);
          this.tableLoading = false;
          this.$store.commit("closeConfirmDialog");
        });
    },
  },
};
</script>
<style  scoped>
</style>